import {FormService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        forms: [],
        selectedForm: undefined,
    },

    mutations: {
        saveForms(current, forms) {
            current.forms = [...forms];
        },
        saveSelectedForm(current, form) {
            current.selectedForm = {...form};
        }
    },

    actions: {
        async getFormAction({commit}, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await FormService.get(id);
                    commit('saveSelectedForm', rst)
                    return rst;
                }, 'form')
        },
        
        async getFormsAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveForms', await FormService.getAll()), 'form')
        },

        async insertFormAction({commit, state}, form) {
            return await bindLoading(commit,
                async () => {
                    const res = await FormService.insert({...form});
                    if (res.success) {
                        commit('saveForms', [res.instance, ...state.forms]);
                    }
                    return res;
                }, 'form',{exposure:true});
        },

        async removeFormAction({commit, state}, id) {
            return await bindLoading(commit,
                async () => {
                    const res = await FormService.remove(id);
                    if (res.success) {
                        commit('saveForms', state.forms.filter(f => f.id !== id));
                    }
                    return res;
                }, 'form');
        },

        async updateFormAction({commit, state}, form) {
            return await bindLoading(commit,
                async () => {
                    const res = await FormService.update({...form});
                    if (res.success) {
                        commit('saveForms', [res.instance, ...state.forms.filter(s => s.id !== form.id)]);
                    }
                    return res;
                }, 'form/update');
        },
        
        async getFormsByInfo({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await FormService.getFormActionByInfo(item);
                    if (res.success) {
                        commit('saveForms', res.instance);
                    } else {
                        commit('saveForms', []);
                    }
                    return res;
                }, 'form');
        }
    }
};